import styled, { css } from 'styled-components'

import Button from 'components/Button'
import Modal from 'components/Modal'

export const CancelButton = styled(Button)`
  &&& {
    margin: 8px 0 0;
  }
`

export const ModalHeader = styled(Modal.Header)`
  padding: 8px 8px 0;
`

export const ModalBody = styled(Modal.Body)`
  &&& {
    margin-top: 0;
    padding: 0 8px 8px;
    border-bottom: none;
  }
`

export const ModalFooter = styled.div<{ hasOverflow?: boolean }>(
  ({ theme, hasOverflow }) => css`
    display: flex;
    flex-direction: column;
    padding: 8px;

    border-top: ${hasOverflow
      ? `1px solid ${theme.colors.border[1]}`
      : undefined};
    text-align: right;

    position: sticky;
    bottom: 0;

    /* Hide the content when it scrolls */
    background: white;
  `
)

export const ItemWrapper = styled.div`
  :not(:empty) {
    padding: 8px;

    max-height: 40vh;
    overflow-y: auto;

    & + & {
      border-top: 1px solid ${({ theme }) => theme.colors.border[2]};
    }
  }
`
